// extracted by mini-css-extract-plugin
export default {"title":"b23TN","discount":"JgABz","tooltip":"YRJWd"};